<template>
	<li>
		<b-form-checkbox
			:checked="isActive"
			:disabled="value.amount === 0"
			@change="setOrUnsetValue"
		>
			{{ value.label }} ({{ value.amount }})
		</b-form-checkbox>
	</li>
</template>

<script>
import _ from "lodash";
import Icon from "@/vue/icon/Icon"
import {isDefined} from "@/helper/Value";
import {mapMutations, mapState} from "vuex";

export default {

	components: {
		Icon,
	},

	props: {
		row: {
			type: Object,
			required: true,
		},
		value: {
			type: Object,
			required: true,
		},
	},

	computed: {
		...mapState('job/fuzzyMatrix', [
			'filterValues',
		]),
		filterData ()
		{
			return {
				id: this.value.id,
				value: this.value.value,
				label: this.value.label,
				type: this.value.type,
				row: {
					id: this.row.id,
					label: this.row.label,
				},
			};
		},
		isActive ()
		{
			return _
				.filter(this.filterValues, innerValue => innerValue.id === this.value.id)
				.length > 0;
		},
	},

	methods: {
		...mapMutations('job/fuzzyMatrix', [
			'setFilterValues'
		]),
		setOrUnsetValue ()
		{
			const value = this.filterData;

			let filterValues = this.filterValues;

			const alreadyIn = isDefined(
				_.find(filterValues, innerValue => innerValue.id === value.id)
			);

			if (alreadyIn)
			{
				filterValues = _.filter(filterValues, innerValue => innerValue.id !== value.id);
			}
			else
			{
				filterValues.push(value);
			}

			this.setFilterValues(filterValues);
		},
	},
}
</script>
